import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const token = () => localStorage.getItem("fr_token") || localStorage.getItem("token") || "";
const auth = () => ({ headers: { Authorization: `Bearer ${token()}` } });

let _tenantTok = null;
export const setPhotoTenantToken = (t) => { _tenantTok = t; };
export const photoUrl = (p) => {
  const path = p.path || p;
  const q = _tenantTok ? `t=${encodeURIComponent(_tenantTok)}` : `auth=${encodeURIComponent(token())}`;
  return `${BASE}/api/inspections/walk-photo/${path}?${q}`;
};

// Same surface for staff (JWT + inspection id) and tenant (magic-link token).
export function makeWalkApi({ mode, id, token: tok }) {
  const staff = mode === "staff";
  setPhotoTenantToken(staff ? null : tok);
  const root = staff ? `${BASE}/api/inspections/${id}` : `${BASE}/api/inspections/public/tenant/${tok}`;
  const cfg = staff ? auth() : {};
  return {
    staff,
    async load() {
      const r = await axios.get(staff ? root : `${root}/walk`, cfg);
      return r.data;
    },
    async photo(roomIdx, blob, { item, takenAt } = {}) {
      const fd = new FormData();
      fd.append("room_idx", String(roomIdx));
      if (item) fd.append("item", item);
      if (takenAt) fd.append("taken_at", takenAt);
      fd.append("file", blob, `walk-${Date.now()}.jpg`);
      const r = await axios.post(`${root}/walk/photo`, fd, { ...cfg, headers: { ...(cfg.headers || {}), "Content-Type": "multipart/form-data" } });
      return r.data;
    },
    item: (body) => axios.patch(`${root}/walk/item`, body, cfg).then(r => r.data),
    async unsorted(blob, { takenAt } = {}) {
      const fd = new FormData();
      if (takenAt) fd.append("taken_at", takenAt);
      fd.append("file", blob, blob.name || `import-${Date.now()}.jpg`);
      const r = await axios.post(`${root}/walk/unsorted`, fd, { ...cfg, headers: { ...(cfg.headers || {}), "Content-Type": "multipart/form-data" } });
      return r.data;
    },
    assignUnsorted: (body) => axios.post(`${root}/walk/unsorted/assign`, body, cfg).then(r => r.data),
    aiSort: (body) => axios.post(`${root}/walk/unsorted/ai-sort`, body || {}, cfg).then(r => r.data),
    callouts: (body) => axios.patch(`${root}/walk/photo/callouts`, body, cfg).then(r => r.data),
    deletePhoto: (body) => axios.post(`${root}/walk/photo/delete`, body, cfg).then(r => r.data),
    room: (body) => axios.patch(`${root}/walk/room`, body, cfg).then(r => r.data),
    measure: (body) => axios.post(`${root}/walk/measure`, body, cfg).then(r => r.data),
    nameplate: (body) => staff ? axios.post(`${root}/walk/nameplate`, body, cfg).then(r => r.data) : Promise.resolve({ ok: false }),
    findingWo: (body) => staff ? axios.post(`${root}/walk/finding-wo`, body, cfg).then(r => r.data) : Promise.resolve({ ok: false }),
    submit: (body) => axios.post(`${root}/submit`, body || {}, cfg).then(r => r.data),
    tenantLink: () => staff ? axios.post(`${root}/tenant-link`, {}, cfg).then(r => r.data) : Promise.resolve(null),
  };
}

export const RATING = {
  good: { label: "Good", bg: "bg-emerald-600", text: "text-emerald-400", ring: "ring-emerald-500" },
  fair: { label: "Fair", bg: "bg-yellow-400 text-slate-900", text: "text-yellow-400", ring: "ring-yellow-400" },
  dmg:  { label: "Damage", bg: "bg-red-600", text: "text-red-400", ring: "ring-red-500" },
  na:   { label: "N/A", bg: "bg-slate-500", text: "text-slate-300", ring: "ring-slate-400" },
};

export const roomPhotos = (room) => ((room.steps || [])[0]?.photos) || [];
export const roomLabel = (room) => room.custom_name ? `${room.name} · ${room.custom_name}` : room.name;
